{
  "title": "Enquiries",
  "subtitle": "Messages from the public contact form and from Get help inside the portal.",
  "newCount": "{{count}} new",
  "statusNew": "New",
  "statusHandled": "Handled",
  "statusSpam": "Spam",
  "loadError": "Could not load enquiries",
  "goneTitle": "That enquiry is gone",
  "goneBody": "The link pointed at an enquiry that is no longer here — it may have been removed, or the address was mistyped.",
  "emptyNewTitle": "Nothing waiting",
  "emptyNewBody": "Everything waiting has been dealt with.",
  "emptyOtherTitle": "Nothing here",
  "emptyOtherBody": "No enquiries marked {{status}}.",
  "handledBy": "handled by {{name}}",
  "reply": "Reply",
  "markHandled": "Mark handled",
  "markSpam": "Spam",
  "markNew": "Reopen",
  "markedVerb": "{{name}} marked {{verb}}.",
  "updateError": "Could not update that enquiry.",
  "replyTitle": "Reply to {{name}}",
  "replyBody": "Your reply",
  "sendReply": "Send reply",
  "replySent": "Reply sent to {{email}}.",
  "replyError": "Could not send that reply.",
  "getHelp": "Get help",
  "getHelpTitle": "Get help",
  "getHelpHint": "Tell us what you need. OnBrand Mail staff will reply by email.",
  "messageLabel": "Message",
  "messagePlaceholder": "What you are trying to do, and what is getting in the way.",
  "send": "Send",
  "helpSent": "Message sent. We will reply by email.",
  "helpRateLimited": "A few messages in a short time — try again in a few minutes.",
  "helpSendError": "Could not send that. Please try again.",
  "noAccessTitle": "No access to enquiries",
  "noAccessBody": "Messages from the public site are read by OnBrand Mail staff.",
  "footerNote": "Enquiries arrive from the public site's contact form and from Get help in the portal. Site messages are not customers yet — a tenant is created from the Tenants screen once there is something to onboard. Portal help already names the organisation.",
  "replySendsFrom": "Sends from OnBrand Mail to {{email}}. Their reply comes back to the support inbox.",
  "verbHandled": "handled",
  "verbSpam": "spam",
  "verbReopened": "new again"
}
